export const RECENT_RUN_WORKFLOW_ID_LIMIT = 100;

export function getRecentRunWorkflowIds(workflowIds: readonly string[]): string[] {
  return workflowIds.slice(0, RECENT_RUN_WORKFLOW_ID_LIMIT);
}

export function buildRecentWorkflowRunsUrl(params: {
  apiUrl: string;
  workflowIds: readonly string[];
  limit?: number;
}): string {
  const searchParams = new URLSearchParams({ limit: String(params.limit ?? 10) });
  for (const workflowId of getRecentRunWorkflowIds(params.workflowIds)) {
    searchParams.append('workflowId', workflowId);
  }
  return `${params.apiUrl}/workflows/runs/recent?${searchParams.toString()}`;
}

/**
 * Bounded URL for the batched open-issues lookup — same shape as
 * {@link buildRecentWorkflowRunsUrl} but with `workflowIds` comma-joined
 * (matches `parseRecentRunWorkflowIds`'s `workflowIds` support on the API).
 */
export function buildOpenIssuesUrl(params: {
  apiUrl: string;
  workflowIds: readonly string[];
}): string {
  const searchParams = new URLSearchParams({
    workflowIds: getRecentRunWorkflowIds(params.workflowIds).join(','),
  });
  return `${params.apiUrl}/workflows/open-issues?${searchParams.toString()}`;
}
